import DateFnsUtils from '@date-io/date-fns';
import { Grid } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';
import moment from 'moment';
import React, { FC, ReactNode, useEffect, useState } from 'react'
import { DateUtil } from 'src/framework/commons';



export interface InputDateProperties {
    id?: string;
    name?: string;
    className?: string;
    label: string;
    format?: string;
    value?: any;
    defaultValue?: string;
    pattern?: string;
    size?: "small" | "medium";
    fullWidth: boolean;
    error?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    margin?: "normal" | "dense" | "none";
    type?: "date" | "datetime-local";
    InputProps?: any;
    inputProps?: any;
    maxDate?: Date | string;
    minDate?: Date | string;
    prefix?: ReactNode;
    onKeyPress?: Function;
    onKeyUp?: Function;
    onKeyDown?: Function;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onFocus?: Function;
    onChange?: (date: string | null) => void,
    helperText?: string
}

interface Position {
    mouseX: any,
    mouseY: any,
}

const initialPosition = {
    mouseX: null,
    mouseY: null,
}


const InputDate: FC<InputDateProperties> = ({
    name,
    className,
    id = "input-date",
    type = "date",
    label,
    value,
    defaultValue,
    size = "small",
    fullWidth = true,
    error = false,
    readonly = false,
    disabled = false,
    InputProps,
    inputProps,
    maxDate,
    minDate,
    margin = "normal",
    prefix,
    onKeyPress,
    onKeyUp,
    onKeyDown,
    onBlur,
    onFocus,
    onChange,
    helperText
}) => {
    const [position, setPosition] = useState<Position>(initialPosition);
    const [errorState, setErrorState] = useState<boolean>(false);

    const handleDateChange = (date: Date | null) => {
        if (onChange) {
            if (date === null) {
                onChange(null);
            } else {
                onChange(moment(date).format("YYYY-MM-DD 00:00:00"));
            }
        }
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        setPosition({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
    }

    const handleClose = () => {
        setPosition(initialPosition);
    };

    const getMaxDate = () => {
        const now = moment().add(-18, "years")
        return now.format("DD/MM/YYYY");
    }

    const handleDate = (option: number) => {
        const data = new Date();
        data.setHours(0);
        data.setMinutes(0);
        data.setSeconds(0);

        switch (option) {
            case 0:
                handleDateChange(data);
                break;
            case 1:
                data.setDate(data.getDate() - 1);
                handleDateChange(data);
                break;
            case 2:
                data.setDate(data.getDate() + 1);
                handleDateChange(data);
                break;
            case 10:
                handleDateChange(DateUtil.firstMonth(DateUtil.decMonth(data)));
                break;
            case 11:
                handleDateChange(DateUtil.lastMonth(DateUtil.decMonth(data)));
                break;
            case 20:
                handleDateChange(DateUtil.firstMonth(data));
                break;
            case 21:
                handleDateChange(DateUtil.lastMonth(data));
                break;
            case 30:
                handleDateChange(DateUtil.firstMonth(DateUtil.incMonth(data)));
                break;
            case 31:
                handleDateChange(DateUtil.lastMonth(DateUtil.incMonth(data)));
                break;
            case 40:
                handleDateChange(new Date(data.getFullYear(), 0, 1));
                break;
            case 41:
                handleDateChange(new Date(data.getFullYear(), 11, 31));
                break;
            case 99:
                handleDateChange(null);
                break;
            default: break;
        }

        setPosition(initialPosition);
    }

    const parseValue = (valueString: string): string | null => {
        let _value = valueString;

        if (_value === "") {
            return null
        }

        return _value;
    }


    return <>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    autoOk
                    name={name}
                    id={id}
                    helperText={helperText}
                    className={className}
                    variant='inline'
                    inputVariant='outlined'
                    margin={margin}
                    label={label}
                    value={parseValue(value)}
                    defaultValue={defaultValue || value || moment().format("DD/MM/YYYY")}
                    format="dd/MM/yyyy"
                    fullWidth={fullWidth}
                    size={size}
                    disabled={disabled}
                    readOnly={readonly}
                    error={error || errorState}
                    views={["year", "month", "date"]}
                    maxDate={maxDate}
                    minDate={minDate}
                    invalidDateMessage={"A data informada é inválida."}
                    minDateMessage={`A data não pode ser menor que a data minima (${minDate || "01/01/1900"} )`}
                    maxDateMessage={"Proponente deve ser maior de 18 anos."}
                    onError={(error, value) => {
                        setErrorState(error !== "")
                    }}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        size: "small"
                    }}
                    InputLabelProps={{
                        shrink: true
                    }}
                    InputProps={{
                        fullWidth: fullWidth,
                        startAdornment: prefix
                    }}
                    onBlur={onBlur}
                />
            </Grid>
        </MuiPickersUtilsProvider>
        {/* <InputText
            id={id}
            name={name}
            className={className}
            label={label}
            margin={margin}
            value={value}
            defaultValue={defaultValue}
            size={size}
            fullWidth={fullWidth}
            disabled={disabled}
            readonly={readonly}
            error={error}
            prefix={prefix}
            type={type}
            InputProps={InputProps}
            inputProps={inputProps}
            onChange={(event: any) => {
                if (onChange) {
                    onChange(event.target.value)
                }
            }}

        >
        </InputText> */}
        {/* <Menu
                keepMounted
                open={position.mouseY !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    position.mouseY !== null && position.mouseX !== null ? { top: position.mouseY, left: position.mouseX } : undefined
                }
            >
                <MenuItem onClick={() => handleDate(0)}>Hoje</MenuItem>
                <MenuItem onClick={() => handleDate(1)}>Ontem</MenuItem>
                <MenuItem onClick={() => handleDate(2)}>Amanhã</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(10)}>Inicio do mês anterior</MenuItem>
                <MenuItem onClick={() => handleDate(11)}>Final do mês anterior</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(20)}>Inicio do mês</MenuItem>
                <MenuItem onClick={() => handleDate(21)}>Final do mês</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(30)}>Inicio do próximo mês</MenuItem>
                <MenuItem onClick={() => handleDate(31)}>Final do próximo mês</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(40)}>Início do ano</MenuItem>
                <MenuItem onClick={() => handleDate(41)}>Final do ano</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(99)}>Limpar</MenuItem>
            </Menu> */}
    </>
}

export { InputDate }